export default __webpack_public_path__ + "static/media/greenExtraSmall.0db49120.svg";